function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import SearchBox from "./search-box";
import Loading from "../elements/loading";
import useInfiniteScroll from "../../hooks/use-infinite-scroll";
import { CSSTransition } from "react-transition-group";
import numeral from "numeral";

var ListboxContent = function ListboxContent(_ref) {
  var searchable = _ref.searchable,
      handleSearch = _ref.handleSearch,
      loading = _ref.loading,
      children = _ref.children,
      _ref$filteredCount = _ref.filteredCount,
      filteredCount = _ref$filteredCount === void 0 ? 0 : _ref$filteredCount,
      _ref$scrollFetch = _ref.scrollFetch,
      scrollFetch = _ref$scrollFetch === void 0 ? function () {} : _ref$scrollFetch,
      _ref$disableSearch = _ref.disableSearch,
      disableSearch = _ref$disableSearch === void 0 ? false : _ref$disableSearch,
      _ref$setDisableShowSe = _ref.setDisableShowSelected,
      setDisableShowSelected = _ref$setDisableShowSe === void 0 ? function () {} : _ref$setDisableShowSe,
      _ref$maxSelections = _ref.maxSelections,
      maxSelections = _ref$maxSelections === void 0 ? 0 : _ref$maxSelections,
      _ref$isMaxSelections = _ref.isMaxSelections,
      isMaxSelections = _ref$isMaxSelections === void 0 ? false : _ref$isMaxSelections;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var scrollableRef = useRef();

  var handleScrollFetch = function handleScrollFetch() {
    return scrollFetch(searchValue);
  };

  useInfiniteScroll(scrollFetch ? handleScrollFetch : undefined, scrollableRef.current);
  useEffect(function () {
    setDisableShowSelected(searchValue !== "");
  }, [searchValue, setDisableShowSelected]);

  var loadingOrEmpty = function loadingOrEmpty() {
    if (loading) return /*#__PURE__*/React.createElement(Loading, {
      position: "center",
      size: "small"
    });
    if (!filteredCount) return /*#__PURE__*/React.createElement("li", {
      className: "et-listbox--no-results"
    }, "No results");
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, searchable && /*#__PURE__*/React.createElement("div", {
    className: "et-listbox--search"
  }, /*#__PURE__*/React.createElement(SearchBox, {
    disabled: disableSearch,
    placeholder: "Search...",
    onChange: function onChange(val) {
      setSearchValue(val);
      handleSearch(val);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "et-listbox--search-count",
    role: "status"
  }, filteredCount, " results shown.")), /*#__PURE__*/React.createElement("div", {
    className: classNames("et-listbox--content-list", {
      "et-listbox--content-list-searchable": searchable
    })
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    in: isMaxSelections,
    timeout: 500,
    classNames: "et-listbox--max-warning-transition",
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "et-listbox--max-warning"
  }, "Select ", numeral(maxSelections).format("0,0"), " items max")), /*#__PURE__*/React.createElement("ul", {
    className: "et-listbox--scrollable-content",
    ref: scrollableRef
  }, loadingOrEmpty() || children)));
};

ListboxContent.propTypes = {
  searchable: PropTypes.bool.isRequired,
  handleSearch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
  filteredCount: PropTypes.number,
  scrollFetch: PropTypes.func,
  disableSearch: PropTypes.bool,
  setDisableShowSelected: PropTypes.func,
  maxSelections: PropTypes.number,
  isMaxSelections: PropTypes.bool
};
export default ListboxContent;